module.exports = __webpack_public_path__ + "img/coding.fd7c533d.jpeg";